import { render } from "./TeamForm.vue?vue&type=template&id=0729a8ed"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__